import { Node } from 'prosemirror-to-html-js';

export default class CodeBlock extends Node {
  matching() {
    return this.node.type === "code_block" || this.node.type === "codeBlock";
  }

  tag() {
    return [
      {
        tag: "pre"
      },
      {
        tag: "code"
      }
    ];
  }
}
